<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Sujet</label>
      </div>
      <input v-model="dataForm.sujet"
             placeholder="Entrez un sujet"
             name="message_sujet"
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Message</label>
      </div>
      <textarea v-model="dataForm.message"
                name="message_message"
                class="form-control"
                placeholder="Entrez un message">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Destinataires</label>
      </div>
      <textarea v-model="dataForm.destinataires"
                name="message_destinataire"
                placeholder="Entrez un ou des destinataires"
                class="form-control">
      </textarea>
    </div>
    <div class="mt-4 mb-3 text-center">
      <button type="submit" class="btn btn-sm btn-success">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
  name: "Update",
  props: {
    message: {
      type: Object
    }
  },
  data() {
    return {
      staffs: null,
      joueurs: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        sujet: '',
        message: '',
        destinataires: '',
        table: 'messages',
        table_id: this.message.message_id,
      }
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
      location.reload(false)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPutData',
    ]),
    onSubmit() {
      this.resetDefaultValues()
      this.axiosPutData(this.dataForm)
          .then((data) => {
            if(data.status === 204)
              this.messageSuccess = "Message envoyé avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de l'envoie du message !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de l'envoie du message !"
          })
    },
    resetDefaultValues() {
      if(this.dataForm.sujet === '')
        this.dataForm.sujet = this.destinataires.sujet
      if(this.dataForm.message === '')
        this.dataForm.message = this.destinataires.message
      if(this.dataForm.destinataires === '')
        this.dataForm.destinataires = this.destinataires.destinataires
    },
    setDefaultValues() {
      const destinataires = Object.assign({}, this.destinataires);
      this.dataForm.sujet = destinataires.sujet
      this.dataForm.message = destinataires.message
      this.dataForm.destinataires = destinataires.destinataires
    }
},
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    this.setDefaultValues()
    //
    this.axiosGetAllData({
      table: 'staffs'
    })
        .then((data) => {
          this.staffs = data.data
        })
        .catch((data) => {
          this.staffs = data
        })
    //
    this.axiosGetAllData({
      table: 'joueurs'
    })
        .then((data) => {
          this.joueurs = data.data
        })
        .catch((data) => {
          this.joueurs = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/messages/components/Update.vue